angular.module('LBACompenSafeSite.Directives', [])
    .filter('utc', function () {

        return function (val) {
            if ((null === val) || (undefined === val)) {
                return val;
            }

            var date = new Date(val);

            return new Date(date.getFullYear(),
                            date.getMonth(),
                            date.getDate(),
                            date.getHours(),
                            date.getMinutes(),
                            date.getSeconds());
        };

    })
    .directive('myDirective', ['$filter', function ($filter) {
        return {
            restrict: 'A',
            scope: {
                myDirective: '='
            },
            link: function (scope, element, attrs) {
                // set the initial value of the textbox
                element.val($filter('date')($filter('utc')(scope.myDirective), 'MM/dd/yyyy'));
                element.data('old-value', $filter('date')($filter('utc')(scope.myDirective), 'MM/dd/yyyy'));

                // detect outside changes and update our input
                scope.$watch('myDirective', function (val) {
                    element.val($filter('date')($filter('utc')(scope.myDirective), 'MM/dd/yyyy'));
                });

                // on blur, update the value in scope
                element.on('propertychange keyup paste', function (blurEvent) {
                    if (element.data('old-value') != element.val()) {
                        console.log('value changed, new value is: ' + element.val());
                        scope.$apply(function () {
                            scope.myDirective = element.val();
                            element.data('old-value', element.val());
                        });
                    }
                });

                $(function () {
                    element.datepicker({
                        dateFormat: 'mm/dd/yy',
                        onSelect: function (date) {
                            scope.$apply(function () {
                                scope.myDirective = element.val();
                                element.data('old-value', element.val());
                            });
                        }
                    });
                });
            }
        };
    }])
    .directive('myDateDirective', ['$filter', function ($filter) {
        return {
            restrict: 'A',
            scope: {
                myDateDirective: '='
            },
            link: function (scope, element, attrs) {
                // set the initial value of the textbox
                element.val($filter('date')(scope.myDateDirective, 'MM/dd/yyyy'));
                element.data('old-value', $filter('date')(scope.myDateDirective, 'MM/dd/yyyy'));

                // detect outside changes and update our input
                scope.$watch('myDateDirective', function (val) {
                    if (isValidDate(val)) {
                        element.val($filter('date')(scope.myDateDirective, 'MM/dd/yyyy'));
                    }
                    else {
                        element.val(val);
                    }
                });

                // on blur, update the value in scope
                element.on('propertychange keyup paste', function (blurEvent) {
                    //validate string is a valid date, 4 digit year only
                    var re = new RegExp("^(1[0-2]|0?[1-9])/(3[01]|[12][0-9]|0?[1-9])/[0-9]{4}$");
                    var m = re.exec(element.val());

                    if (null != m && isValidDate(element.val()) && element.data('old-value') != element.val()) {
                        console.log('value changed, new value is: ' + element.val());
                        scope.$apply(function () {
                            scope.myDateDirective = element.val();
                            element.data('old-value', element.val());
                        });
                    }
                    else if (angular.isUndefined(element.val()) || element.val() == "" || element.val() === null) {
                        scope.$apply(function () {
                            scope.myDateDirective = null;
                            element.data('old-value', null);
                        });
                    }
                });

                $(function () {
                    element.datepicker({
                        dateFormat: 'mm/dd/yy',
                        constrainInput: false,
                        changeYear: true,
                        yearRange: "-100:+10",
                        onSelect: function (date) {
                            scope.$apply(function () {
                                console.log('element.val() = ' + element.val());
                                scope.myDateDirective = element.val();
                                element.data('old-value', element.val());
                            });
                            $(this).closest('.ui-dialog-content').trigger('focus');
                        }
                    });
                });
            }
        };
    }])
    .directive('openTierDialog', function () {
        return {
            restrict: 'A',
            link: function (scope, elem, attr, ctrl) {
                var elemId = '#' + attr.id;
                var dialogId = '#' + attr.openTierDialog;
                var tn = scope.tempTier.TierNumber;
                elem.on('click', function (e) {
                    var $s = microappscope(elemId);

                    var cnt = $s.overrideSchedule.Tiers.length;
                    var tt = parseInt($s.overrideSchedule.TierType);

                    if ((cnt >= 1) && (0 == tt)) {
                        //flat tier type still selected
                        $s.Alert.Message = 'You must pick a Tier Type other than Flat.';
                        $s.openAlertDialog();
                    }
                    else {
                        var tn = $s.overrideSchedule.Tiers.length + 1;
                        $s.tempTier = {
                            IsNew: true,
                            TierNumber: tn,
                            TierGoalUnits: 0,
                            TierGoalVol: null,
                            TierPayAmt: 0,
                        };
                        $s.$apply();

                        $(dialogId).dialog({ title: 'Tier ' + tn }).dialog('open');
                    }
                });
            }
        }
    })
    .directive('ngAddEmployeeConfirmClick', ['$window', function ($window) {
        return {
            priority: -1,
            restrict: 'A',
            link: function (scope, element, attrs) {
                var btnID = '#' + attrs.id;

                element.on('click', function (e) {
                    var $s = microappscope(btnID);
                    var isDirty = $s.IsDirty();

                    var message = attrs.ngConfirmClick;
                    if (isDirty && message && !confirm(message)) {
                        e.stopImmediatePropagation();
                        e.preventDefault();
                    }
                    else {
                        $window.location.href = GetEmpOverrideUrl + '?overrideid=' + $s.originalOverrideSchedule.OverrideID;
                    }
                });
            }
        }
    }])
    .directive('openInactivateDialog', function () {
        return {
            restrict: 'A',
            link: function (scope, elem, attr, ctrl) {
                var elemId = '#' + attr.id;
                var dialogId = '#' + attr.openInactivateDialog;
                var tn = scope.tempTier.TierNumber;
                elem.on('click', function (e) {
                    var $s = microappscope(elemId);
                    $s.$apply($(dialogId).dialog('open'));
                });
            }
        }
    })
    .directive('mhiDialog', ['$timeout', function ($timeout) {
        return {
            scope: {
                okButton: '@',
                okCallback: '=',
                cancelButton: '@',
                cancelCallback: '=',
                threeButton: '@',
                threeCallback: '=',
                open: '@',
                title: '@',
                width: '@',
                height: '@',
                show: '@',
                hide: '@',
                autoOpen: '@',
                resizable: '@',
                closeOnEscape: '@',
                hideCloseButton: '@'
            },
            replace: false,
            transclude: true,    // transclusion allows for the dialog 
            // contents to use angular {{}}
            template: '<div ng-transclude></div>',      // the transcluded content
            //is placed in the div
            link: function (scope, element, attrs) {
                // Close button is hidden by default
                var hideCloseButton = attrs.hideCloseButton || true;

                // Specify the options for the dialog
                var dialogOptions = {
                    autoOpen: attrs.autoOpen || false,
                    title: attrs.title,
                    width: attrs.width || 350,
                    height: attrs.height || 200,
                    modal: attrs.modal || false,
                    show: attrs.show || '',
                    hide: attrs.hide || '',
                    draggable: attrs.draggable || true,
                    resizable: attrs.resizable,
                    closeOnEscape: attrs.closeOnEscape || true,

                    close: function () {
                        console.log('closing...');
                    },
                    open: function (event, ui) {
                        //TODO: figure out how to do this without searching the DOM
                        // Hide close button 
                        if (hideCloseButton == true) {
                            $(".ui-dialog-titlebar-close", ui.dialog).hide();
                        }
                    }
                };

                // Add the buttons 
                dialogOptions['buttons'] = [];
                if (attrs.okButton) {
                    var btnOptions = {
                        text: attrs.okButton,
                        click: function () { scope.$apply(scope.okCallback()); }
                    };
                    dialogOptions['buttons'].push(btnOptions);
                }

                if (attrs.cancelButton) {
                    var btnOptions = {
                        text: attrs.cancelButton,
                        click: function () { scope.$apply(scope.cancelCallback()); }
                    };
                    dialogOptions['buttons'].push(btnOptions);
                }

                if (attrs.threeButton) {
                    var btnOptions = {
                        text: attrs.threeButton,
                        click: function () { scope.$apply(scope.threeCallback()); }
                    };
                    dialogOptions['buttons'].push(btnOptions);
                }

                // Initialize the element as a dialog
                // For some reason this timeout is required, otherwise it doesn't work
                // for more than one dialog
                $timeout(function () {
                    $(element)
                        .prop('hidden', false)
                        .css("visibility", "visible")
                        .css("display", "initial");

                    $(element).dialog(dialogOptions);
                }, 0);

                // This works when observing an interpolated attribute
                // e.g {{dialogOpen}}.  In this case the val is always a string and so
                // must be compared with the string 'true' and not a boolean
                // using open: '@' and open="{{dialogOpen}}"
                attrs.$observe('open', function (val) {
                    if (val == 'true') {
                        if ($(element).hasClass('ui-dialog-content')) {
                            $(element).dialog("open");
                        }
                    }
                    else {
                        if ($(element).hasClass('ui-dialog-content')) {
                            $(element).dialog("close");
                        }
                    }
                });

                // This allows title to be bound
                attrs.$observe('title', function (val) {
                    if ($(element).hasClass('ui-dialog-content')) {
                        $(element).dialog("option", "title", val);
                    }
                });
            }
        }
    }])
    .directive('jqbutton', [function ($timeout) {
        //input control must have name and id and there needs to be a label that's for the input
        return {
            restrict: 'A',
            compile: function (element, attributes) {
                $(element)
                    .button();

                var linkFunction = function ($scope, element, attributes) {
                    $scope.$watch("EditingType", function (newValue, oldValue) {
                        if ('edit' == newValue) {
                            $(element).find("input[type=radio]").checkboxradio({ disabled: false });
                        }
                        else {
                            if (null != newValue) {
                                if (null != $(element)[0].attributes['ng-disabled']) {
                                    $(element).find("input[type=radio]").checkboxradio({ disabled: true });
                                }
                                else {
                                    $(element).find("input[type=radio]").checkboxradio({ disabled: false });
                                }
                            }
                            else {
                                $(element).find("input[type=radio]").checkboxradio({ disabled: false });
                            }
                        }
                        $(element).find("input[type=radio]").checkboxradio('refresh');
                    });
                };

                return linkFunction;
            }
        };
    }])
    .directive('jqbuttonset', [function ($timeout) {
        //input control must have name and id and there needs to be a label that's for the input
        return {
            restrict: 'A',
            compile: function (element, attributes) {
                $(element)
                    .find("input[type=radio]")
                    .checkboxradio({ icon: false });

                var linkFunction = function ($scope, element, attributes) {
                    $scope.$watch("EditingType", function (newValue, oldValue) {
                        if ('edit' == newValue) {
                            $(element).find("input[type=radio]").checkboxradio({ disabled: false });
                        }
                        else {
                            if (null != newValue) {
                                if (null != $(element)[0].attributes['ng-disabled']) {
                                    $(element).find("input[type=radio]").checkboxradio({ disabled: true });
                                }
                                else {
                                    $(element).find("input[type=radio]").checkboxradio({ disabled: false });
                                }
                            }
                            else {
                                $(element).find("input[type=radio]").checkboxradio({ disabled: false });
                            }
                        }
                        $(element).find("input[type=radio]").checkboxradio('refresh');
                    });
                };

                return linkFunction;
            }
        };
    }])
    .directive('format', ['$filter', function ($filter) {
        return {
            require: '?ngModel',
            link: function (scope, elem, attrs, ctrl) {
                if (!ctrl) return;

                var symbol = ""; // dummy usage

                ctrl.$formatters.unshift(function (a) {
                    var val = $filter(attrs.format)(ctrl.$modelValue);
                    return null != val ? val + symbol : null;
                });

                ctrl.$parsers.unshift(function (viewValue) {
                    var plainNumber = viewValue.replace(/[^\d|\-+|\.+]/g, '');
                    if (plainNumber.slice(-1) == '.') {
                        return plainNumber;
                    }
                    elem.val($filter('number')(plainNumber) + symbol);
                    return plainNumber;
                });
            }
        };
    }])
    .directive('myDate', ['$timeout', '$filter', function ($timeout, $filter) {
        //from http://stackoverflow.com/questions/22414788/angularjs-directive-to-format-date
        return {
            require: 'ngModel',
            link: function ($scope, $element, $attrs, $ctrl) {
                var dateFormat = 'MM/dd/yyyy';
                $ctrl.$parsers.push(function (viewValue) {
                    //convert string input into moment data model
                    var pDate = Date.parse(viewValue);
                    if (isNaN(pDate) === false) {
                        return new Date(pDate);
                    }
                    return undefined;
                });
                $ctrl.$formatters.push(function (modelValue) {
                    var pDate = Date.parse(modelValue);
                    if (isNaN(pDate) === false) {
                        return $filter('date')(new Date(pDate), dateFormat);
                    }
                    return undefined;
                });
                $element.on('blur', function () {
                    var pDate = Date.parse($ctrl.$modelValue);
                    if (isNaN(pDate) === true) {
                        $ctrl.$setViewValue(null);
                        $ctrl.$render();
                    } else {
                        if ($element.val() !== $filter('date')(new Date(pDate), dateFormat)) {
                            $ctrl.$setViewValue($filter('date')(new Date(pDate), dateFormat));
                            $ctrl.$render();
                        }
                    }
                });
            }
        };
    }])
    .directive('datepicker', function () {
        return function (scope, element, attrs) {
            element.datepicker({
                inline: true,
                dateFormat: 'mm/dd/yy',
                onSelect: function (dateText) {
                    var modelPath = $(this).attr('ng-model');
                    putObject(modelPath, scope, dateText);
                    scope.$apply();
                }
            });
        }
    })
    .directive('accordion', function () {
        return {
            restrict: 'A',
            link: function ($scope, $element, attrs) {
                $element.accordion();
            }
        };
    })
    .directive('numbersOnly', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, modelCtrl) {
                modelCtrl.$parsers.push(function (inputValue) {
                    // this next if is necessary for when using ng-required on your input. 
                    // In such cases, when a letter is typed first, this parser will be called
                    // again, and the 2nd time, the value will be undefined
                    if (inputValue == undefined) return ''
                    var transformedInput = inputValue.replace(/([^-0-9+.])|(-{2})/g, '');
                    if (transformedInput != inputValue) {
                        modelCtrl.$setViewValue(transformedInput);
                        modelCtrl.$render();
                    }

                    return transformedInput;
                });
            }
        };
    })
    .directive('defaultSrc', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.on('error', function () {
                    if (attrs.src != attrs.defaultSrc) {
                        attrs.$set('src', attrs.defaultSrc);
                    }
                });
            }
        };
    })
    .directive('percent', function () {
        return {
            require: '?ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                if (!ngModelCtrl) {
                    return;
                }

                ngModelCtrl.$parsers.unshift(
                    function (viewValue) {
                        if (angular.isUndefined(viewValue)) {
                            clean = '';
                        }
                        var clean = viewValue.toString().replace(/[^0-9]+/g, '');
                        if (clean.substring(0, 3) == '100') {
                            clean = '100';
                        }
                        else if (parseInt(clean) > 100) {
                            clean = clean.substring(0, 2);
                        }
                        var percent = clean.concat('');
                        if (viewValue.toString() !== percent) {
                            ngModelCtrl.$setViewValue(percent);
                            ngModelCtrl.$render();
                        }
                        return parseFloat(percent) / 100;
                    }
                );
                ngModelCtrl.$formatters.unshift(
                    function (modelValue) {
                        return parseFloat(modelValue) * 100;
                    }
                );
            }
        };
    })
    .directive('convertToNumber', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function (val) {
                    return parseInt(val, 10);
                });
                ngModel.$formatters.push(function (val) {
                    return '' + val;
                });
            }
        };
    })
    .directive('onlyAlphanumerics', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attr, ngModelCtrl) {
                function fromUser(text) {
                    var transformedInput = text.replace(/[^0-9a-zA-Z]/g, '');
                    console.log(transformedInput);
                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
                ngModelCtrl.$parsers.push(fromUser);
            }
        };
    })
;

function microappscope(id) {
    return angular.element($(id)).scope();
}